import styled, {css} from 'styled-components'
import React, { Component } from 'react';

const X = styled.p`
  position: absolute;
  top: 4px;
  right: 7px;
  font-size: 3rem;
  line-height: 1;
  transform: none;
  font-family: "Arial", sans-serif;
  font-weight: light;
  cursor: crosshair;
  z-index: 150;

  ${props => props.white && css`
    color: white;
  `}
`

export default (props) => {
  return (
    <X white={props.white} onClick={() => props.onClick()}>×</X>
  )
}



// WEBPACK FOOTER //
// ./src/components/X.js